import { NavLink, Outlet } from "react-router-dom";
import "./AppShellLayout.css";

const NAV_ITEMS = [
  { to: "/app/monitor", label: "Monitor", icon: MonitorIcon },
  { to: "/app/providers", label: "Providers", icon: ProvidersIcon },
  { to: "/app/widget", label: "Widget", icon: WidgetIcon },
  { to: "/app/profile", label: "Profile", icon: ProfileIcon },
];

export default function AppShellLayout() {
  return (
    <div className="tg-shell">
      <aside className="tg-sidebar">
        <div className="tg-sidebar__brand">
          <span className="tg-sidebar__mark">TG</span>
          <span className="tg-sidebar__name">TokenGuard</span>
        </div>
        <nav className="tg-sidebar__nav">
          {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `tg-navitem ${isActive ? "tg-navitem--active" : ""}`}
            >
              <Icon />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        {/* No UpdateBanner here -- that's the desktop app's silent
            auto-updater UI, tied to @tauri-apps/plugin-updater and
            -process, neither of which exists on the website (or makes
            sense here -- there's no binary to update, a website visitor
            always has "the current version" by definition). */}
      </aside>
      <main className="tg-main">
        <div className="tg-main__scroll tg-scroll">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

function MonitorIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 12h4l3 8 4-16 3 8h4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
function ProvidersIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M10 13a5 5 0 007.07 0l2.83-2.83a5 5 0 00-7.07-7.07L11.5 4.5" strokeLinecap="round" />
      <path d="M14 11a5 5 0 00-7.07 0L4.1 13.83a5 5 0 007.07 7.07l1.34-1.34" strokeLinecap="round" />
    </svg>
  );
}
function WidgetIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </svg>
  );
}
function ProfileIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 4-6 8-6s8 2 8 6" strokeLinecap="round" />
    </svg>
  );
}
